import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0529ed28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "error-message px-6"
}

import { useRouter } from 'vue-router'
import { computed } from 'vue'

import IconButton from '@/popup/components/shared/IconButton.vue'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'
import AppIdenticon from '@/popup/components/shared/AppIdenticon/AppIdenticon.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { useAppStore } from '@/popup/store/AppStore'
import { t } from '@/popup/lib/i18n'
import Notification from '@/popup/components/shared/Notification.vue'
import { useUIStore } from '@/popup/store/UIStore'
import { useNotifications } from '@/popup/compositions/useNotifications'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { PopupRouteMap } from '@/popup/main'
import { generateSalt } from '@/shared/utils'
import getUniqueId from '@/shared/getUniqueId'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNewAccountFrame',
  setup(__props) {

const router = useRouter()
const appStore = useAppStore()
const approvalsStore = useApprovalsStore()

const uiStore = useUIStore()
const toast = computed(() => uiStore.toast)
const notifications = useNotifications()

const createPassword = (password: string) => {
  router.push({
    path: '/create-account',
    name: 'confirmPassword',
    query: { password },
  })
}
const confirmPassword = async (password: string) => {
  const unlockedOrError = await useGlobals().sendMessage({
    method: InternalMethods.UNLOCK,
    payload: {
      password,
    },
  })
  if (!unlockedOrError.success) {
    notifications.updateToast({
      id: getUniqueId(),
      message: t('create_new_account.password_fail'),
      profileAddress: '',
      method: DBNotifications.NOTIFICATION,
      system: false,
      type: ToastType.ERROR,
      isPersistent: false,
    })
    return
  }

  const appId = generateSalt()
  await appStore.handleCreatedAccount({ appId })
  const approval = approvalsStore.nonStashedApprovals[0]
  const path = approval
    ? PopupRouteMap[approval.type] + `/${approval.id}`
    : '/home'
  router.push({ path })
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppIdenticon),
      _createVNode(IconButton, {
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/welcome'))),
        class: "mt-5"
      }),
      (toast.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Notification, { type: "error" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(toast.value.message), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, [
        _createVNode(_component_router_view, {
          onCreatePassword: createPassword,
          onConfirmPassword: confirmPassword
        })
      ])
    ]),
    _createVNode(NetworkSwitchWrapper)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})